var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { LIMIT_VALUES, DURATION_UNIT_VALUES } from '../../constants/dropdowns';
import { validateInteger, getConstraints } from '../../utils/helpers';
import { FlightSelect, FlightTextInput } from '@flybits/design-system';
var HistoricalQueries = function (renderProps) {
    var _a, _b, _c, _d, _e, _f;
    var uiBlock = renderProps.uiBlock, updateUiBlock = renderProps.updateUiBlock, valueMissing = renderProps.valueMissing;
    var _g = getConstraints(uiBlock), isValueLocked = _g.isValueLocked, operationConstraint = _g.operationConstraint;
    var DEFAULT_CLASS = 'historical-queries';
    var OPTION_FIELD_WIDTH = '120px';
    var TEXT_FIELD_WIDTH = '80px';
    var _h = __read(useState(((_a = uiBlock.historicalValue) === null || _a === void 0 ? void 0 : _a.histOperator)
        ? LIMIT_VALUES.find(function (option) { var _a; return option.exp === ((_a = uiBlock.historicalValue) === null || _a === void 0 ? void 0 : _a.histOperator); })
        : LIMIT_VALUES[0]), 2), selectedLimit = _h[0], setSelectedLimit = _h[1];
    var _j = __read(useState(((_b = uiBlock.historicalValue) === null || _b === void 0 ? void 0 : _b.histValue) ? (_c = uiBlock.historicalValue) === null || _c === void 0 ? void 0 : _c.histValue : ''), 2), selectedFrequency = _j[0], setSelectedFrequency = _j[1];
    var _k = __read(useState(((_d = uiBlock.historicalValue) === null || _d === void 0 ? void 0 : _d.duration) ? (_e = uiBlock.historicalValue) === null || _e === void 0 ? void 0 : _e.duration : ''), 2), selectedDuration = _k[0], setSelectedDuration = _k[1];
    var _l = __read(useState(((_f = uiBlock.historicalValue) === null || _f === void 0 ? void 0 : _f.durationUnit)
        ? DURATION_UNIT_VALUES.find(function (option) { var _a; return option.name === ((_a = uiBlock.historicalValue) === null || _a === void 0 ? void 0 : _a.durationUnit); })
        : DURATION_UNIT_VALUES[0]), 2), selectedDurationUnit = _l[0], setSelectedDurationUnit = _l[1];
    var _m = __read(useState(false), 2), freqValueMissing = _m[0], setFreqValueMissing = _m[1];
    var _o = __read(useState(false), 2), durationValueMissing = _o[0], setDurationValueMissing = _o[1];
    var checkIfEmpty = function (value, type) {
        if (type === 'frequency') {
            if (value === '') {
                setFreqValueMissing(true);
            }
            else {
                setFreqValueMissing(false);
            }
        }
        else {
            if (value === '') {
                setDurationValueMissing(true);
            }
            else {
                setDurationValueMissing(false);
            }
        }
    };
    var handleDropdownChange = function (option, type) {
        switch (type) {
            case 'limit': {
                setSelectedLimit(option);
                var histValue = uiBlock.historicalValue || {};
                histValue.histOperator = option.exp;
                updateUiBlock(__assign(__assign({}, uiBlock), { histOperator: option.exp, historicalValue: histValue }));
                break;
            }
            case 'unit': {
                setSelectedDurationUnit(option);
                var histValue = uiBlock.historicalValue || {};
                histValue.durationUnit = option.name;
                updateUiBlock(__assign(__assign({}, uiBlock), { durationUnit: option.name, historicalValue: histValue }));
                break;
            }
        }
    };
    var handleTermChange = function (option, type) {
        var isInteger = validateInteger(option);
        if (option === '' || isInteger) {
            switch (type) {
                case 'frequency': {
                    checkIfEmpty(option, 'frequency');
                    setSelectedFrequency(option);
                    var histValue = uiBlock.historicalValue || {};
                    histValue.histValue = option;
                    updateUiBlock(__assign(__assign({}, uiBlock), { histValue: option, historicalValue: histValue }));
                    break;
                }
                case 'duration': {
                    checkIfEmpty(option, 'duration');
                    setSelectedDuration(option);
                    var histValue = uiBlock.historicalValue || {};
                    histValue.duration = option;
                    updateUiBlock(__assign(__assign({}, uiBlock), { duration: option, historicalValue: histValue }));
                    break;
                }
            }
        }
    };
    return (React.createElement("div", { className: "".concat(DEFAULT_CLASS) },
        React.createElement("div", { className: "".concat(DEFAULT_CLASS, "__container ").concat(DEFAULT_CLASS, "__first-container") },
            React.createElement("span", { className: "".concat(DEFAULT_CLASS, "__container__arrow") }),
            React.createElement(FlightSelect, { className: "".concat(DEFAULT_CLASS, "__container__limit"), options: LIMIT_VALUES, selected: selectedLimit, disabled: operationConstraint === 'locked', handleOptionClick: function (option) { return handleDropdownChange(option, 'limit'); }, width: OPTION_FIELD_WIDTH }),
            React.createElement(FlightTextInput, { className: "".concat(DEFAULT_CLASS, "__container__frequency"), value: selectedFrequency, onChange: function (e) { return handleTermChange(e.target.value, 'frequency'); }, onBlur: function (e) { return checkIfEmpty(e.target.value, 'frequency'); }, disabled: isValueLocked, width: TEXT_FIELD_WIDTH, hasError: freqValueMissing }),
            React.createElement("span", { className: "".concat(DEFAULT_CLASS, "__container__label") }, 'time(s)')),
        React.createElement("br", null),
        React.createElement("div", { className: "".concat(DEFAULT_CLASS, "__container ").concat(DEFAULT_CLASS, "__second-container") },
            React.createElement("span", { className: "".concat(DEFAULT_CLASS, "__container__arrow") }),
            React.createElement("span", { className: "".concat(DEFAULT_CLASS, "__container__label") }, 'in the past'),
            React.createElement(FlightTextInput, { className: "".concat(DEFAULT_CLASS, "__container__duration"), value: selectedDuration, onChange: function (e) { return handleTermChange(e.target.value, 'duration'); }, onBlur: function (e) { return checkIfEmpty(e.target.value, 'duration'); }, disabled: operationConstraint !== '', width: TEXT_FIELD_WIDTH, hasError: durationValueMissing }),
            React.createElement(FlightSelect, { className: "".concat(DEFAULT_CLASS, "__container__duration_unit"), options: DURATION_UNIT_VALUES, selected: selectedDurationUnit, handleOptionClick: function (option) { return handleDropdownChange(option, 'unit'); }, disabled: operationConstraint !== '', width: OPTION_FIELD_WIDTH })),
        (durationValueMissing || freqValueMissing || valueMissing) && (React.createElement("span", { className: "".concat(DEFAULT_CLASS, "__container flight-select__error-message") }, "Value must not be empty"))));
};
export default HistoricalQueries;
//# sourceMappingURL=HistoricalQueries.js.map